var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    xmlns: "http://www.w3.org/2000/svg",
    height: 43,
    id: "screenshot-2bd33f28-acce-8023-8007-4569c0c4a001",
    viewBox: "0 0 43 43",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4a001"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame-clip-2bd33f28-acce-8023-8007-4569c0c4a001-render-1",
    className: "frame-clip frame-clip-def"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 43.00000000000023,
    height: 42.99999999999994,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame-clip-2bd33f28-acce-8023-8007-4569c0c4a001-render-1)",
    fill: "none"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4a001"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 43.00000000000023,
    height: 42.99999999999994,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4a002",
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4a003",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4a003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.30000000000018,
    height: 42.299999999999955,
    x: -0.4082299216224783,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none"
    },
    ry: 0,
    fill: "none",
    rx: 0,
    y: -0.04487239495392714
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dca1"
  }, /*#__PURE__*/React.createElement("defs", {
    style: {
      fill: "rgb(0, 0, 0)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dca2",
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dca3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4dca3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4617919921875,30.495101928710938L14.7117919921875,30.495101928710938C13.7916259765625,30.495101928710938,13.0516357421875,29.765121459960938,13.0516357421875,28.855148315429688C13.0516357421875,27.945114135742188,13.7916259765625,27.215133666992188,14.7117919921875,27.215133666992188L29.4617919921875,27.215133666992188L29.4617919921875,30.495101928710938Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-e05a5b47-a79e-8058-8007-467737fb0e2c-2bd33f28-acce-8023-8007-4569c0c4dca3",
    className: "strokes",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4617919921875,30.495101928710938L14.7117919921875,30.495101928710938C13.7916259765625,30.495101928710938,13.0516357421875,29.765121459960938,13.0516357421875,28.855148315429688C13.0516357421875,27.945114135742188,13.7916259765625,27.215133666992188,14.7117919921875,27.215133666992188L29.4617919921875,27.215133666992188L29.4617919921875,30.495101928710938Z",
    style: {
      fill: "none",
      strokeWidth: 1,
      stroke: "rgb(120, 120, 120)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dca4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4dca4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0115966796875,19.685104370117188L26.7615966796875,19.685104370117188C27.6817626953125,19.685104370117188,28.4217529296875,20.415145874023438,28.4217529296875,21.325119018554688C28.4217529296875,22.235153198242188,27.6817626953125,22.965133666992188,26.7615966796875,22.965133666992188L12.0115966796875,22.965133666992188L12.0115966796875,19.685104370117188Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-e05a5b47-a79e-8058-8007-467737fbfdd8-2bd33f28-acce-8023-8007-4569c0c4dca4",
    className: "strokes",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0115966796875,19.685104370117188L26.7615966796875,19.685104370117188C27.6817626953125,19.685104370117188,28.4217529296875,20.415145874023438,28.4217529296875,21.325119018554688C28.4217529296875,22.235153198242188,27.6817626953125,22.965133666992188,26.7615966796875,22.965133666992188L12.0115966796875,22.965133666992188L12.0115966796875,19.685104370117188Z",
    style: {
      fill: "none",
      strokeWidth: 1,
      stroke: "rgb(228, 126, 63)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dca5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4dca5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4617919921875,15.365093231201172L14.7117919921875,15.365093231201172C13.7916259765625,15.365093231201172,13.0516357421875,14.635112762451172,13.0516357421875,13.725139617919922C13.0516357421875,12.815105438232422,13.7916259765625,12.085124969482422,14.7117919921875,12.085124969482422L29.4617919921875,12.085124969482422L29.4617919921875,15.365093231201172Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-e05a5b47-a79e-8058-8007-467737fc480e-2bd33f28-acce-8023-8007-4569c0c4dca5",
    className: "strokes",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4617919921875,15.365093231201172L14.7117919921875,15.365093231201172C13.7916259765625,15.365093231201172,13.0516357421875,14.635112762451172,13.0516357421875,13.725139617919922C13.0516357421875,12.815105438232422,13.7916259765625,12.085124969482422,14.7117919921875,12.085124969482422L29.4617919921875,12.085124969482422L29.4617919921875,15.365093231201172Z",
    style: {
      fill: "none",
      strokeWidth: 1,
      stroke: "rgb(195, 195, 195)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dca6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4dca6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2615966796875,13.775127410888672C33.5716552734375,13.775127410888672,33.8316650390625,14.035137176513672,33.8316650390625,14.335124969482422C33.8316650390625,14.635112762451172,33.5716552734375,14.895122528076172,33.2615966796875,14.895122528076172C32.9517822265625,14.895122528076172,32.6917724609375,14.635112762451172,32.6917724609375,14.335124969482422C32.6917724609375,14.035137176513672,32.9517822265625,13.775127410888672,33.2615966796875,13.775127410888672Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(152, 152, 152)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dca7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4dca7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5516357421875,30.495101928710938L30.5516357421875,32.65513610839844L14.7117919921875,32.65513610839844C13.6617431640625,32.65513610839844,12.7017822265625,32.22514343261719,12.0015869140625,31.535140991210938C11.3016357421875,30.845138549804688,10.8717041015625,29.895126342773438,10.8717041015625,28.855148315429688C10.8717041015625,26.785140991210938,12.5716552734375,25.055099487304688,14.7117919921875,25.055099487304688L30.5516357421875,25.055099487304688L30.5516357421875,27.215133666992188L14.7117919921875,27.215133666992188C14.2716064453125,27.215133666992188,13.8416748046875,27.385116577148438,13.5316162109375,27.695114135742188C13.2218017578125,27.995101928710938,13.0516357421875,28.385116577148438,13.0516357421875,28.865097045898438C13.0516357421875,29.775131225585938,13.7916259765625,30.505111694335938,14.7117919921875,30.505111694335938L30.5516357421875,30.505111694335938Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(195, 195, 195)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dca8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4dca8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7117919921875,17.525131225585938C28.8016357421875,17.525131225585938,30.5516357421875,19.205123901367188,30.5516357421875,21.325119018554688C30.5516357421875,22.365097045898438,30.1116943359375,23.315109252929688,29.4217529296875,24.005111694335938C28.7218017578125,24.695114135742188,27.7615966796875,25.125106811523438,26.7117919921875,25.125106811523438L10.8717041015625,25.125106811523438L10.8717041015625,22.965133666992188L26.7117919921875,22.965133666992188C27.6317138671875,22.965133666992188,28.3717041015625,22.235153198242188,28.3717041015625,21.325119018554688C28.3717041015625,20.895126342773438,28.2017822265625,20.465133666992188,27.8917236328125,20.155136108398438C27.5816650390625,19.845138549804688,27.1917724609375,19.675094604492188,26.7117919921875,19.675094604492188L10.9117431640625,19.675094604492188L10.9117431640625,17.515121459960938L26.7117919921875,17.515121459960938Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(255, 144, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dca9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4dca9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5516357421875,15.365093231201172L30.5516357421875,17.525131225585938L14.7117919921875,17.525131225585938C13.6617431640625,17.525131225585938,12.7017822265625,17.095138549804688,12.0015869140625,16.405132293701172C11.3016357421875,15.715129852294922,10.8717041015625,14.765117645263672,10.8717041015625,13.725139617919922C10.8717041015625,11.655132293701172,12.5716552734375,9.925090789794922,14.7117919921875,9.925090789794922L30.5516357421875,9.925090789794922L30.5516357421875,12.085124969482422L14.7117919921875,12.085124969482422C14.2716064453125,12.085124969482422,13.8416748046875,12.255107879638672,13.5316162109375,12.565105438232422C13.2218017578125,12.865093231201172,13.0516357421875,13.255107879638672,13.0516357421875,13.735149383544922C13.0516357421875,14.645122528076172,13.7916259765625,15.375102996826172,14.7117919921875,15.375102996826172L30.5516357421875,15.375102996826172Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(152, 152, 152)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dcaa"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4dcaa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7916259765625,21.845138549804688C35.9918212890625,22.045150756835938,36.1917724609375,22.345138549804688,36.1917724609375,22.745101928710938C36.1917724609375,23.445114135742188,35.5916748046875,24.035140991210938,34.8817138671875,24.035140991210938C34.5816650390625,24.035140991210938,34.1817626953125,23.935104370117188,33.9818115234375,23.635116577148438C33.7816162109375,23.335128784179688,33.5816650390625,23.135116577148438,33.5816650390625,22.745101928710938C33.5816650390625,22.355148315429688,33.6817626953125,22.045150756835938,33.9818115234375,21.845138549804688C34.1817626953125,21.645126342773438,34.4818115234375,21.445114135742188,34.8817138671875,21.445114135742188C35.2816162109375,21.445114135742188,35.5816650390625,21.645126342773438,35.7816162109375,21.845138549804688Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-e05a5b47-a79e-8058-8007-467737fdf059-2bd33f28-acce-8023-8007-4569c0c4dcaa",
    className: "strokes",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7916259765625,21.845138549804688C35.9918212890625,22.045150756835938,36.1917724609375,22.345138549804688,36.1917724609375,22.745101928710938C36.1917724609375,23.445114135742188,35.5916748046875,24.035140991210938,34.8817138671875,24.035140991210938C34.5816650390625,24.035140991210938,34.1817626953125,23.935104370117188,33.9818115234375,23.635116577148438C33.7816162109375,23.335128784179688,33.5816650390625,23.135116577148438,33.5816650390625,22.745101928710938C33.5816650390625,22.355148315429688,33.6817626953125,22.045150756835938,33.9818115234375,21.845138549804688C34.1817626953125,21.645126342773438,34.4818115234375,21.445114135742188,34.8817138671875,21.445114135742188C35.2816162109375,21.445114135742188,35.5816650390625,21.645126342773438,35.7816162109375,21.845138549804688Z",
    style: {
      fill: "none",
      strokeWidth: 0.5,
      stroke: "rgb(255, 144, 0)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dcab"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4dcab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0816650390625,29.025131225585938C33.1717529296875,29.115097045898438,33.2515869140625,29.245101928710938,33.2515869140625,29.415145874023438C33.2515869140625,29.715133666992188,32.9918212890625,29.975143432617188,32.6817626953125,29.975143432617188C32.5516357421875,29.975143432617188,32.3717041015625,29.935104370117188,32.2916259765625,29.805099487304688C32.2017822265625,29.715133666992188,32.1217041015625,29.585128784179688,32.1217041015625,29.415145874023438C32.1217041015625,29.285140991210938,32.1617431640625,29.115097045898438,32.2916259765625,29.025131225585938C32.3817138671875,28.935104370117188,32.5115966796875,28.855148315429688,32.6817626953125,28.855148315429688C32.8516845703125,28.855148315429688,32.9918212890625,28.945114135742188,33.0716552734375,29.025131225585938Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(195, 195, 195)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dcac"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4dcac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.0816650390625,9.535137176513672C9.1717529296875,9.625102996826172,9.2515869140625,9.755107879638672,9.2515869140625,9.925090789794922C9.2515869140625,10.225139617919922,8.9918212890625,10.485149383544922,8.6817626953125,10.485149383544922C8.5516357421875,10.485149383544922,8.3717041015625,10.445110321044922,8.2916259765625,10.315105438232422C8.2017822265625,10.225139617919922,8.1217041015625,10.095134735107422,8.1217041015625,9.925090789794922C8.1217041015625,9.755107879638672,8.1617431640625,9.625102996826172,8.2916259765625,9.535137176513672C8.3817138671875,9.445110321044922,8.5115966796875,9.365093231201172,8.6817626953125,9.365093231201172C8.8516845703125,9.365093231201172,8.9918212890625,9.405132293701172,9.0716552734375,9.535137176513672Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(255, 144, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dcad"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4dcad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3016357421875,18.115097045898438C8.5015869140625,18.305099487304688,8.6917724609375,18.595138549804688,8.6917724609375,18.985153198242188C8.6917724609375,19.665145874023438,8.1016845703125,20.245101928710938,7.4217529296875,20.245101928710938C7.1317138671875,20.245101928710938,6.7318115234375,20.145126342773438,6.5416259765625,19.855148315429688C6.3416748046875,19.665145874023438,6.1517333984375,19.375106811523438,6.1517333984375,18.985153198242188C6.1517333984375,18.595138549804688,6.2515869140625,18.305099487304688,6.5416259765625,18.115097045898438C6.7418212890625,17.925094604492188,7.0316162109375,17.725143432617188,7.4217529296875,17.725143432617188C7.8116455078125,17.725143432617188,8.1116943359375,17.915145874023438,8.3016357421875,18.115097045898438Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-e05a5b47-a79e-8058-8007-467737fee783-2bd33f28-acce-8023-8007-4569c0c4dcad",
    className: "strokes",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3016357421875,18.115097045898438C8.5015869140625,18.305099487304688,8.6917724609375,18.595138549804688,8.6917724609375,18.985153198242188C8.6917724609375,19.665145874023438,8.1016845703125,20.245101928710938,7.4217529296875,20.245101928710938C7.1317138671875,20.245101928710938,6.7318115234375,20.145126342773438,6.5416259765625,19.855148315429688C6.3416748046875,19.665145874023438,6.1517333984375,19.375106811523438,6.1517333984375,18.985153198242188C6.1517333984375,18.595138549804688,6.2515869140625,18.305099487304688,6.5416259765625,18.115097045898438C6.7418212890625,17.925094604492188,7.0316162109375,17.725143432617188,7.4217529296875,17.725143432617188C7.8116455078125,17.725143432617188,8.1116943359375,17.915145874023438,8.3016357421875,18.115097045898438Z",
    style: {
      fill: "none",
      strokeWidth: 0.5,
      stroke: "rgb(195, 195, 195)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dcae"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4dcae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8116455078125,25.305099487304688C6.9017333984375,25.395126342773438,6.9818115234375,25.525131225585938,6.9818115234375,25.695114135742188C6.9818115234375,25.995101928710938,6.7218017578125,26.255111694335938,6.4117431640625,26.255111694335938C6.2816162109375,26.255111694335938,6.1016845703125,26.215133666992188,6.0216064453125,26.085128784179688C5.9317626953125,25.995101928710938,5.8516845703125,25.865097045898438,5.8516845703125,25.695114135742188C5.8516845703125,25.525131225585938,5.8917236328125,25.395126342773438,6.0216064453125,25.305099487304688C6.1116943359375,25.215133666992188,6.2418212890625,25.135116577148438,6.4117431640625,25.135116577148438C6.5816650390625,25.135116577148438,6.7218017578125,25.175094604492188,6.8016357421875,25.305099487304688Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(195, 195, 195)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dcaf"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4dcaf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2716064453125,28.335128784179688C13.9617919921875,28.335128784179688,13.7017822265625,28.595138549804688,13.7017822265625,28.895126342773438C13.7017822265625,29.195114135742188,13.9617919921875,29.455123901367188,14.2716064453125,29.455123901367188L29.4617919921875,29.455123901367188L29.4617919921875,28.375106811523438L14.2716064453125,28.375106811523438L14.2716064453125,28.335128784179688Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(120, 120, 120)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dcb0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4dcb0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8416748046875,21.235153198242188C27.8416748046875,20.935104370117188,27.5816650390625,20.675094604492188,27.2716064453125,20.675094604492188L12.0015869140625,20.675094604492188L12.0015869140625,21.755111694335938L27.3116455078125,21.755111694335938C27.5716552734375,21.795150756835938,27.8316650390625,21.535140991210938,27.8316650390625,21.235153198242188Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(228, 126, 63)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dcb1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4dcb1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0416259765625,13.205120086669922C13.7318115234375,13.205120086669922,13.4718017578125,13.465129852294922,13.4718017578125,13.765117645263672C13.4718017578125,14.065105438232422,13.7318115234375,14.325115203857422,14.0416259765625,14.325115203857422L29.4617919921875,14.325115203857422L29.4617919921875,13.245098114013672L20.1717529296875,13.245098114013672L14.0416259765625,13.205120086669922Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(195, 195, 195)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569c0c4dcb2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569c0c4dcb2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.741770078377613,
    cy: 21.10512760504605,
    rx: 20.90000000000009,
    ry: 20.899999999999977,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-e05a5b47-a79e-8058-8007-467738007e01-2bd33f28-acce-8023-8007-4569c0c4dcb2",
    className: "strokes",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.741770078377613,
    cy: 21.10512760504605,
    rx: 20.90000000000009,
    ry: 20.899999999999977,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none",
      strokeWidth: 0.5,
      stroke: "rgb(244, 140, 78)",
      strokeOpacity: 1
    }
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.5ded4f4e1724836ebeaa50bd3e3504c9.svg";
export { ForwardRef as ReactComponent };